export default "__VITE_ASSET__CCS6MDLe__"